import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orgDisplayName' })
export class OrgDisplayNamePipe implements PipeTransform {
  transform(org: any): string {
    let orgDisplayName = '';
    if (org) {
      const orgNameList = org.fullParentPathName.split('.');
      if (org.level === 1) {
        orgDisplayName = `${org.cgac} - ${orgNameList[0]}`;
      } else if (org.level === 2) {
        orgDisplayName = `${org.fpdsCode} - ${orgNameList[1]}`;
      } else {
        orgDisplayName = `${org.aacCode || org.fpdsOrgId} - ${
          orgNameList[orgNameList.length - 1]
        }`;
      }
    }
    return orgDisplayName;
  }
}
